import { api } from '@/api/client';
import type { CurrentUser } from '@/api/types';

export async function getCurrentUser(): Promise<CurrentUser> {
  return (await api.get<CurrentUser>('/auth/me')).data;
}
